export default __webpack_public_path__ + "static/media/lib-3.ffa9821e.webp";